import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import SignUpPage from './SignUpPage';
import {
  saveCustomerName,
  saveCustomerType,
  saveFirstname,
  saveLastname,
  saveEmail,
  // savePhonenumber,
  saveAddressOne,
  saveAddressTwo,
  saveCountry,
  saveState,
  saveProduct,
  saveScanner,
  saveCommand,
  saveCity,
  saveZipcode,
  savePoc,
  savePocemail,
  savePocphonenumber,
  saveProductportfolio,
  saveDesignsoftware,
  saveVersionofsoftware,
  saveTrunaroundservice,
  savePreferenceform,
  saveMaterialfiles,
  doSignup,
  doSignupUpload
} from '../../actions/signupAction';
import { handleCloseAlert } from 'src/actions/errorAction';
import { push } from 'react-router-redux';

export const mapStateToProps = (state: AppState) => {
  return {
    btnElement: 'Sign-up to Troubleshoot',
    btnType: 'signup',
    errorMessage: state.errorState.errorMessage,
    errorBar: state.errorState.errorBar,
    successMessage: state.errorState.successMessage,
    successBar: state.errorState.successBar,

    customername: state.signupUser.customername,
    customertype: state.signupUser.customertype,
    customerfirstname: state.signupUser.customerfirstname,
    contactPhonenumber: state.signupUser.customerlastname,
    customeremail: state.signupUser.customeremail,
    customerphonenumber: state.signupUser.customerphonenumber,
    customeraddressone: state.signupUser.customeraddressone,
    customeraddresstwo: state.signupUser.customeraddresstwo,
    customercountry: state.signupUser.customercountry,
    customerstate: state.signupUser.customerstate,
    customerproduct: state.signupUser.customerproduct,
    customerscanner: state.signupUser.customerscanner,
    customercommand: state.signupUser.customercommand,
    customercity: state.signupUser.customercity,
    customerzipcode: state.signupUser.customerzipcode,
    customerpoc: state.signupUser.customerpoc,
    customerpocemail: state.signupUser.customerpocemail,
    customerpocphonenumber: state.signupUser.customerpocphonenumber,
    customerproductportfolio: state.signupUser.customerproductportfolio,
    customerdesignsoftware: state.signupUser.customerdesignsoftware,
    customerversionofsoftware: state.signupUser.customerversionofsoftware,
    customerturnaroundservice: state.signupUser.customerturnaroundservice,
    customerpreferenceform: state.signupUser.customerpreferenceform,
    customermaterialfiles: state.signupUser.customermaterialfiles,
    // customerPOC: state.signupUser.customerPOC,
    // customerPOCEmail: state.signupUser.customerPOCEmail,
    // customerPOCPhonenumber: state.signupUser.customerPOCPhonenumber,
    // customerProductPortfolio: state.signupUser.customerProductPortfolio,
    // customerDesignSoftware: state.signupUser.customerDesignSoftware,
    // customerVersionSoftware: state.signupUser.customerVersionSoftware,
    // customerTurnaroundservice: state.signupUser.customerTurnaroundservice,
    // customerPreferenceForm: state.signupUser.customerPreferenceForm,
    // customerMaterialFiles: state.signupUser.customerMaterialFiles,
    // customerBillingcycle: state.signupUser.customerBillingcycle,
    // customerBillingcyclePOC: state.signupUser.customerBillingcyclePOC,
    // customerBillingcycleEmail: state.signupUser.customerBillingcycleEmail,
    // customerBillingcyclePhonenumber: state.signupUser.customerBillingcyclePhonenumber,
    // customerTermsandConditions: state.signupUser.customerTermsandConditions,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onSubmit: () => {
      // dispatch(fetchCurrentUser);
      dispatch(doSignupUpload);
      dispatch(doSignup);
    },
    onLogin: () => {
      dispatch(push('/login'));
    },
    saveCustomerName: (customername: string) => {
      dispatch(saveCustomerName(customername));
    },
    saveCustomerType: (customertype: string) => {
      dispatch(saveCustomerType(customertype));
    },
    saveFirstname: (customerfirstname: string) => {
      dispatch(saveFirstname(customerfirstname));
    },
    saveLastname: (customerlastname: string) => {
      dispatch(saveLastname(customerlastname));
    },
    saveEmail: (customeremail: string) => {
      dispatch(saveEmail(customeremail));
    },
    // savePhonenumber: (customerphonenumber: string) => {
    //   dispatch(savePhonenumber(customerphonenumber));
    // },
    saveAddressOne: (customeraddressone: string) => {
      dispatch(saveAddressOne(customeraddressone));
    },
    saveAddressTwo: (customeraddresstwo: string) => {
      dispatch(saveAddressTwo(customeraddresstwo));
    },
    saveCountry: (customercountry: string) => {
      dispatch(saveCountry(customercountry));
    },
    saveState: (customerstate: string) => {
      dispatch(saveState(customerstate));
    },
    saveProduct: (customerproduct: string) => {
      dispatch(saveProduct(customerproduct));
    },
    saveScanner: (customerscanner: string) => {
      dispatch(saveScanner(customerscanner));
    },
    saveCommand: (customercommand: string) => {
      dispatch(saveCommand(customercommand));
    },
    saveCity: (customercity: string) => {
      dispatch(saveCity(customercity));
    },
    saveZipcode: (customerzipcode: string) => {
      dispatch(saveZipcode(customerzipcode));
    },
    savePoc: (customerpoc: string) => {
      dispatch(savePoc(customerpoc));
    },
    savePocemail: (customerpocemail: string) => {
      dispatch(savePocemail(customerpocemail));
    },
    savePocphonenumber: (customerpocphonenumber: string) => {
      dispatch(savePocphonenumber(customerpocphonenumber));
    },
    saveProductportfolio: (customerproductportfolio: string) => {
      dispatch(saveProductportfolio(customerproductportfolio));
    },
    saveDesignsoftware: (customerdesignsoftware: string) => {
      dispatch(saveDesignsoftware(customerdesignsoftware));
    },
    saveVersionofsoftware: (customerversionofsoftware: string) => {
      dispatch(saveVersionofsoftware(customerversionofsoftware));
    },
    saveTrunaroundservice: (customerturnaroundservice: string) => {
      dispatch(saveTrunaroundservice(customerturnaroundservice));
    },
    savePreferenceform: (customerpreferenceform: File) => {
      dispatch(savePreferenceform(customerpreferenceform));
    },
    saveMaterialfiles: (customermaterialfiles: File) => {
      dispatch(saveMaterialfiles(customermaterialfiles));
    },
    handleClose: () => {
      dispatch(handleCloseAlert);
    },
    handleCloseOpen: () => {
      dispatch(handleCloseAlert);
      dispatch(push('/login'));
    },
    onComponentDidMount: () => {
      dispatch(saveCustomerType('Lab'));
      dispatch(saveCountry(''));
    }
  };
};

const SignUpPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpPage);

export default SignUpPageContainer;



// WEBPACK FOOTER //
// ./src/components/signup/SignUpPageContainer.tsx